// 按钮显示逻辑
export const listButton = function ({
	paidDepositFlag,
	depositWay,
	paidDepositAmount,
	maxDepositAmount,
	status,
	myDiscussQuantity,
	myDealQuantity,
	orderId,
	orderStatus,
	finishQuantity

}) {
	let bid,
		deposit,
		toBegin,
		partIn,
		winner,
		failure,
		end,
		exit,
		failed,
		repair, confirmOrder, viewOrder = false;
	let statusText = '';
	let statusTextList = {
		"30": "即将开始",
		"40": "正在进行",
		"50": "已结束",
		"60": "已结束",
	}
	statusText = statusTextList[status];
	partIn = (status == "30" || status == "40") && paidDepositFlag == "00" && depositWay == "00";
	deposit =
		(status == "30" || status == "40") &&
		depositWay !== "00" &&
		paidDepositAmount < maxDepositAmount;
	repair = status == '40' && depositWay !== '00' && (paidDepositAmount < maxDepositAmount);
	toBegin =
		status == "30" &&
		((paidDepositFlag == "01" && depositWay == "00") ||
			(depositWay !== "00" && paidDepositAmount == maxDepositAmount));
	bid = status == "40" && paidDepositFlag == '01';
	winner = (status == "50" || status == "60") && myDealQuantity > 0;
	failure =
		(status == "50" || status == "60") &&
		myDealQuantity == 0 &&
		myDiscussQuantity > 0;
	end = (status == "50" || status == "60") && myDiscussQuantity == 0 && finishQuantity > 0;
	exit = status == '40' && myDealQuantity == 0 && paidDepositAmount > 0;
	confirmOrder = orderId != null && orderStatus == '0_1'; //  显示“确认订单”
	viewOrder = orderId != null && orderStatus != '0_1';   //显示“查看订单”
	failed = (status == '50' || status == '60') && finishQuantity == 0;
	return {
		bid, //出价
		deposit, //保证金
		toBegin,//即将开始
		partIn,//参与
		winner,//中标
		failure,//未中标
		failed,//流标
		end,//结束
		exit,//退出
		repair,//补缴
		statusText,//当前状态
		confirmOrder,//确定订单
		viewOrder//查看订单,
	};
};

export const viewText = details => {
	if (!details) {
		return {};
	}
	// this.for
	let selectEle = {
		auModeList: {
			"10": "最低价成交",
			"20": "出价成交"
		},
		dissussWayList: {
			"10": "公开报价",
			"20": "封闭报价"
		},
		assessmentFlagList: {
			"1": "计入考核",
			"0": "不计入考核"
		},
		payDeadlineDayList: {
			// 0: "当天",
			// 1: "第一天",
		},
	};
	// let codeSet = JSON.parse(localStorage.getItem('codeSet'));
	// if (codeSet['PAY_DEADLINE_DAY'] && codeSet['PAY_DEADLINE_DAY'].length) {
	// 	codeSet['PAY_DEADLINE_DAY'].forEach(item => {
	// 		selectEle.payDeadlineDayList[item.itemCode] = item.itemName;
	// 	})
	// }
	// console.log(selectEle)

	let auMode = selectEle.auModeList[details.auMode]; // 竞拍模式
	let dissussWay = selectEle.dissussWayList[details.dissussWay]; //出价方式
	let assessmentFlag = selectEle.assessmentFlagList[details.assessmentFlag]; //是否计入考核
	let deliveryWay = ""; //提货方式
	let delayFlag = details.delayFlag == 1 ? "有延时" : "无延时";
	let depositWayList = {
		"00": "无需保证金",
		"10": `固定金额 ${details.depositAmount} 元`,
		"20": `按起拍价比例 ${details.depositRatio}%`
	};
	let depositWay = depositWayList[details.depositWay]; //保证金
	let payDeadline = ''; //支付期限
	if (details.payDeadlineType == '0') {
		payDeadline = `竞拍结束后:${details.paymentTimeLimit} 小时`; //支付期限
	} else if (details.payDeadlineType == '1') {
		payDeadline = `${selectEle.payDeadlineDayList[details.payDeadlineDay] || ''} ${details.payDeadlineTime}`; //支付期限
	}
	// debugger;
	if (details.deliveryWay) {
		let arr = { "10": "自提", "20": "配送" };
		let arrText = details.deliveryWay.match(/\d+/g).map(item => {
			return arr[item];
		});
		deliveryWay = arrText.join();
	}

	return {
		auMode,
		dissussWay,
		assessmentFlag,
		deliveryWay,
		delayFlag,
		depositWay,
		payDeadline
	};
}

export const auctionImg = {
	auctionSuccess: require("@/assets/auction/icon-success-bid.png"),
	auctionFailed: require("@/assets/auction/icon-failed-bid.png"),
	auctionFailure: require("@/assets/auction/icon-failure-bid.png"),
	auctionEnd: require("@/assets/auction/icon-end-bid.png"),
};


export const priceValidator = (prop, initValue, stepValue, text = "", total) => {
	return (
		{
			prop,
			rules: {
				required: true,
				validator (rule, value, callback) {
					let result = (value - initValue) < 0 || (value - initValue) % stepValue !== 0;
					if (value === "") {
						callback(new Error(`${text}不能为空`));
						return;
					}
					if (result) {
						callback(new Error(`${text}错误`));
						return;
					}
					if (total && value > total) {
						callback(new Error(`${text}不能超出总量${total}`));
						return;
					}

					callback();

				},
				trigger: "blur",
			}
		}
	)
}

// 出价 提示窗
export const bidModal = function ({ maxDiscussNumber }, callback) {
	this.$Modal.confirm({
		title: `请注意：您只有 ${maxDiscussNumber} 次出价机会！`,
		content: "",
		onOk: async () => {
			callback()
		},
		onCancel: () => {
			// this.$Message.info("Clicked cancel");
		}
	});
}